import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface FilterCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
  onReset: () => void;
  onFilter: () => void;
}

const FilterCard = ({
  title,
  description,
  children,
  onReset,
  onFilter,
}: FilterCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>{children}</CardContent>
      <CardFooter className="flex justify-between">
        <Button variant="outline" onClick={onReset}>
          Reset
        </Button>
        <Button onClick={onFilter}>Generate Report</Button>
      </CardFooter>
    </Card>
  );
};

export default FilterCard;
